import React from 'react';
import { motion } from 'framer-motion';
const companies = ['Barclays', 'Access Bank', 'Longrich', 'EY', 'British Telecoms', 'LeaDe', '21st 100 Network'];
// Duplicate for seamless loop
const marqueeItems = [...companies, ...companies];
export function CompanyLogos() {
  return <section className="bg-dark-900 py-14 border-t border-white/5 overflow-hidden" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-8" data-id="element-19">
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-sm text-gray-500" data-id="element-20">
          Our graduates work at
        </motion.p>
      </div>

      {/* Marquee track */}
      <div className="relative w-full overflow-hidden" data-id="element-21">
        {/* Left fade */}
        <div className="absolute left-0 top-0 h-full w-10 z-10 pointer-events-none" style={{
        background: 'linear-gradient(to right, #0a0a0a, transparent)'
      }} data-id="element-22" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 h-full w-10 z-10 pointer-events-none" style={{
        background: 'linear-gradient(to left, #0a0a0a, transparent)'
      }} data-id="element-23" />

        <motion.div className="flex items-center gap-x-16 w-max opacity-50" animate={{
        x: ['0%', '-50%']
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'linear'
      }} data-id="element-24">
          {marqueeItems.map((company, i) => <span key={i} className="text-xl font-semibold text-gray-400 tracking-tight whitespace-nowrap" data-id="element-25">
              {company}
            </span>)}
        </motion.div>
      </div>
    </section>;
}